import DrawRepository from './draw.repository'
import VersionRepository from './version.repository'

export default {
  draw: DrawRepository,
  version: VersionRepository,
}
